import * as React from "react";

import type { DesignaliProps } from "../../types";

export const MessageSquareDashed = React.forwardRef<
  SVGSVGElement,
  DesignaliProps
>(({ ...props }, forwardedRef) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
      ref={forwardedRef}
    >
      <path d="M10 17H7l-4 4v-7" />
      <path d="M14 17h1" />
      <path d="M14 3h1" />
      <path d="M19 3a2 2 0 0 1 2 2" />
      <path d="M21 14v1a2 2 0 0 1-2 2" />
      <path d="M21 9v1" />
      <path d="M3 9v1" />
      <path d="M5 3a2 2 0 0 0-2 2" />
      <path d="M9 3h1" />
    </svg>
  );
});

export default MessageSquareDashed;
